import React, {useRef, useEffect} from 'react'
import { useSelector } from 'react-redux'
import IframeResizer from "iframe-resizer-react";
import ChatRoulette from "../chat_roulette/chat_roulette";

export default function ChatRoulettePopup({data, onModalClose}) {
  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" onClick={(event) => {
        event.stopPropagation()
      }}>
        <div className="modal-header">
          <div className="modal-title">
            {data.title}
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body" style={{minHeight: "55vh"}}>
          <style>
            {`
            .eyeson-video {
              max-width: 100%;
            }
            `}
          </style>
          <ChatRoulette/>
        </div>
      </div>
    </div>
  </div>
}
